import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdb173d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cash-paymant-page" }
const _hoisted_2 = { class: "cash-paymant-block" }
const _hoisted_3 = { class: "cash-paymant-block-name" }
const _hoisted_4 = { class: "first-subsection" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "second-subsection" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label justify-self-center" }
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = {
  class: "p-ripple submit-btn",
  "data-index": "4",
  type: "submit",
  form: "paymentForm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!
  const _component_TotalRow = _resolveComponent("TotalRow")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: _ctx.$t('newOrder.add-cash-payment')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        action: "",
        id: "paymentForm",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('cashier.label.cash')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cashier.label.amount')), 1),
          _createVNode(_component_NumberInput, {
            modelValue: _ctx.payment.amount,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payment.amount) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.amount,
            mode: 'decimal',
            minFractionDigits: 2,
            maxFractionDigits: 2,
            inputProps: { 'data-index': 1 },
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([1])), ["prevent"]), ["enter"]))
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('cashier.label.currency')), 1),
          _createVNode(_component_DropdownInput, {
            onChange: _ctx.changeCurrency,
            modelValue: _ctx.payment.currencyId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payment.currencyId) = $event)),
            options: _ctx.currencies,
            optionLabel: "name",
            optionValue: "id",
            placeholder: _ctx.$t('cashier.placeholder.select-currency'),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.currencyId,
            inputProps: { 'data-index': 2 }
          }, null, 8, ["onChange", "modelValue", "options", "placeholder", "scope", "rules"]),
          (_ctx.localCurrencyId != _ctx.payment.currencyId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('cashier.label.rate')), 1),
                _createVNode(_component_NumberInput, {
                  modelValue: _ctx.payment.localCurrencyRate,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payment.localCurrencyRate) = $event)),
                  scope: _ctx.validation.scope,
                  rules: _ctx.validation.rules.localCurrencyRate,
                  readonly: !_ctx.canEditRate,
                  minFractionDigits: 1,
                  maxFractionDigits: 3,
                  inputProps: { 'data-index': 3 },
                  onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.focusNext([3])), ["prevent"]), ["enter"]))
                }, null, 8, ["modelValue", "scope", "rules", "readonly"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ], 32),
      _createVNode(_component_TotalRow, {
        total: _ctx.total,
        paymentCurrencyId: _ctx.payment.currencyId
      }, null, 8, ["total", "paymentCurrencyId"]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t('cashier.add-payment')), 1)
        ])), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createVNode(_component_BackAndCancelFooter)
  ]))
}